

import React, { useState, useEffect, useContext } from 'react';
import JobRoleService from "../../controller/JobRoleController/JobRoleController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";
import CreateJobRole from './CreateJobRole';
import HelpSite from "../../../Common/HelpLink";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import Cookies from "js-cookie";
function JobRoleListPage() {
    const navigate = useNavigate();
    const [jobRoleList, setJobRoles] = useState([]);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [modalInstance, setModalInstance] = useState(null);
    const [currentJobRole, setCurrentJobRole] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`TeamSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`TeamSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const fetchJobRoles = async (page, size) => {
        try {
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            const jobRoleData = await JobRoleService.GetAllJobRole(redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setJobRoles(jobRoleData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    useEffect(() => {
        fetchJobRoles(currentPage, pageSize);

    }, [currentPage, pageSize]);
    useEffect(() => {
        fetchJobRoles(currentPage, pageSize);

    }, [sortConfig]);


    const handleCreateJobRoleClick = () => {
        setCurrentJobRole(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {

        setIsModalOpen(false);
    };
    const handleSuccess = () => {
        fetchJobRoles("0",pageSize);
        setIsModalOpen(false);
    };
    const handleEditClick = (jobRole) => {
        setCurrentJobRole(jobRole); // Set the team to be edited
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation();
        Swal.fire({
            title: 'Are you sure?',
            text: `Are you sure you want to delete`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await JobRoleService.DeleteJobRole(ID);
                    await fetchJobRoles("0",pageSize);
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });



    };
    const HelpLink = localStorage.getItem('HelpLink');

    const defaultColumns = [
        "JobRole",
       
    ];
    const defaultColumnsForSearch = [
        "JobRole",
       

    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "JobRole", label: "JobRole" }

    ];
    const columnSearchOptions = [
        { value: "JobRole", label: "JobRole" }
        

    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`courierColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`courierColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page


        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const locationData = await JobRoleService.GetAllJobRole(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setJobRoles(locationData);

    };
    const handleSort = async (key) => {

        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);
        //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const query = searchQuery.toLowerCase();
        const locationData = await JobRoleService.GetAllJobRole(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setJobRoles(locationData);

    };
    return (
        <div>

            <div className="row mb-3">

                <div className="col-sm-3">

                    <Link className='btn btn-primary btn-sm' onClick={handleCreateJobRoleClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </Link>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Depots" Module="26" />
                </div>
            </div>
            <div className="row mb-3">

                <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                    </select>
                </div>
                <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                <div className="col-sm-6"></div>
                <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>


                </div>
                <div className="col-sm-2 d-flex justify-content-end">
                    <input
                        list="recent-searches"
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="form-control me-2"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchButtonClick();
                            }
                        }}
                    />

                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                        <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                </div>


            </div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>

                        <th onClick={() => handleSort('JobRole')}>Position</th>
                        <th style={{ "textAlign": "right" }}></th>
                    </tr>
                </thead><tbody>

                    {jobRoleList.map((jobRole, index) => (

                        <tr key={jobRole.ID} onClick={() => handleEditClick(jobRole)}>

                            <td>{jobRole.JobRole}</td>
                            <td style={{ "textAlign": "right" }}>

                                <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={(event) => handleDeleteClick(event, jobRole.ID)}>
                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {(isModalOpen &&
                <CreateJobRole jobRole={currentJobRole} onClose={handleCloseModal} onSuccess={handleSuccess} />
            )}
        </div>
    );
}

export default JobRoleListPage;